import { Route, Routes } from "react-router-dom";
import Container from "../components/layout/Container";
import MyAccount from "../components/Shared/MyAccount/MyAccount";
import {
  ActiveListing,
  AuctionBuyNowFeeCharts,
  CreateListingFilters,
  ExpiredListing,
  ItemsBiddingOn,
  ItemsWonAndBought,
  ListingFilters,
  MessageChat,
  MyBusinessListing,
  MyListingOffers,
  MyMessages,
  PaidListingFees,
  ReportProblem,
  ReviewsGiven,
  ReviewsPending,
  ReviewsReceieved,
  SoldItems,
  UnpaidListingFees,
  UserAccountInfo,
  WatchList,
} from "../components/UserAccount";

const UserAccount = () => {
  return (
    <Container>
      <div className="grid grid-cols-4 gap-y-6">
        <MyAccount />
        <Routes>
          <Route path="/active" element={<ActiveListing />} />
          <Route path="/expired" element={<ExpiredListing />} />
          <Route path="/bidding-on" element={<ItemsBiddingOn />} />
          <Route path="/won-and-bought" element={<ItemsWonAndBought />} />
          <Route path="/sold-items" element={<SoldItems />} />
          <Route path="/watch-list" element={<WatchList />} />
          <Route path="/listing-filters" element={<ListingFilters />} />
          <Route path="/info" element={<UserAccountInfo />} />
          <Route path="/message" element={<MyMessages />} />
          <Route path="/chat" element={<MessageChat />} />
          <Route path="/report" element={<ReportProblem />} />
          <Route path="/unpaid" element={<UnpaidListingFees />} />
          <Route path="/paid" element={<PaidListingFees />} />
          <Route path="/fee-charts" element={<AuctionBuyNowFeeCharts />} />
          <Route path="/my-business" element={<MyBusinessListing />} />
          <Route path="/listing-offers" element={<MyListingOffers />} />
          <Route
            path="/create-listing-filters"
            element={<CreateListingFilters />}
          />
          <Route path="/reviews-pending" element={<ReviewsPending />} />
          <Route path="/reviews-receieved" element={<ReviewsReceieved />} />
          <Route path="/reviews-given" element={<ReviewsGiven />} />
          <Route path="*" element={<ActiveListing />} />
        </Routes>
      </div>
    </Container>
  );
};

export default UserAccount;
